// Live match score by ID
export const LIVE_MATCH_SCORE_GET_REQUEST = 'matchcenter24/LIVE_MATCH_SCORE/GET_REQUEST';
export const LIVE_MATCH_SCORE_GET_RESPONSE = 'matchcenter24/LIVE_MATCH_SCORE/GET_RESPONSE';
export const LIVE_MATCH_SCORE_GET_INVALIDATE = 'matchcenter24/LIVE_MATCH_SCORE/GET_INVALIDATE';

// Sport events by competition and month
export const SPORTEVENTS_BY_COMPETITION_MONTH_GET_REQUEST =
  'matchcenter24/SPORTEVENTS_BY_COMPETITION_MONTH/GET_REQUEST';
export const SPORTEVENTS_BY_COMPETITION_MONTH_GET_RESPONSE =
  'matchcenter24/SPORTEVENTS_BY_COMPETITION_MONTH/GET_RESPONSE';
export const SPORTEVENTS_BY_COMPETITION_MONTH_GET_INVALIDATE =
  'matchcenter24/SPORTEVENTS_BY_COMPETITION_MONTH/GET_INVALIDATE';

// Sport events by sport and month
export const SPORTEVENTS_BY_SPORT_MONTH_GET_REQUEST =
  'matchcenter24/SPORTEVENTS_BY_SPORT_MONTH/GET_REQUEST';
export const SPORTEVENTS_BY_SPORT_MONTH_GET_RESPONSE =
  'matchcenter24/SPORTEVENTS_BY_SPORT_MONTH/GET_RESPONSE';
export const SPORTEVENTS_BY_SPORT_MONTH_GET_INVALIDATE =
  'matchcenter24/SPORTEVENTS_BY_SPORT_MONTH/GET_INVALIDATE';

// Sport events by date
export const SPORTEVENTS_BY_DATE_GET_REQUEST = 'matchcenter24/SPORTEVENTS_BY_DATE/GET_REQUEST';
export const SPORTEVENTS_BY_DATE_GET_RESPONSE = 'matchcenter24/SPORTEVENTS_BY_DATE/GET_RESPONSE';
export const SPORTEVENTS_BY_DATE_GET_INVALIDATE =
  'matchcenter24/SPORTEVENTS_BY_DATE/GET_INVALIDATE';

// Sport events by season id
export const SPORTEVENTS_BY_SEASON_ID_GET_REQUEST =
  'matchcenter24/SPORTEVENTS_BY_SEASON_ID/GET_REQUEST';
export const SPORTEVENTS_BY_SEASON_ID_GET_RESPONSE =
  'matchcenter24/SPORTEVENTS_BY_SEASON_ID/GET_RESPONSE';
export const SPORTEVENTS_BY_SEASON_ID_GET_INVALIDATE =
  'matchcenter24/SPORTEVENTS_BY_SEASON_ID/GET_INVALIDATE';

// Match info by id
export const MATCHINFO_BY_ID_GET_REQUEST = 'matchcenter24/MATCHINFO_BY_ID/GET_REQUEST';
export const MATCHINFO_BY_ID_GET_RESPONSE = 'matchcenter24/MATCHINFO_BY_ID/GET_RESPONSE';
export const MATCHINFO_BY_ID_GET_INVALIDATE = 'matchcenter24/MATCHINFO_BY_ID/GET_INVALIDATE';

export const MATCHDETAIL_CLEANUP = 'matchcenter24/CLEANUP';

// BetData by id
export const BETDATA_BY_ID_GET_REQUEST = 'matchcenter24/BETDATA_BY_ID/GET_REQUEST';
export const BETDATA_BY_ID_GET_RESPONSE = 'matchcenter24/BETDATA_BY_ID/GET_RESPONSE';
export const BETDATA_BY_ID_GET_INVALIDATE = 'matchcenter24/BETDATA_BY_ID/GET_INVALIDATE';

export const BETDATA_CLEANUP = 'matchcenter24/BETDATA_CLEANUP';

// Match Live Data by id
export const MATCH_LIVE_DATA_BY_ID_GET_REQUEST = 'matchcenter24/MATCH_LIVE_DATA_BY_ID/GET_REQUEST';
export const MATCH_LIVE_DATA_BY_ID_GET_RESPONSE =
  'matchcenter24/MATCH_LIVE_DATA_BY_ID/GET_RESPONSE';
export const MATCH_LIVE_DATA_BY_ID_GET_INVALIDATE =
  'matchcenter24/MATCH_LIVE_DATA_BY_ID/GET_INVALIDATE';

// Timeline command update by sport event id (and optionally last command id)
export const TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_REQUEST =
  'matchcenter24/TIMELINE_CMD_BY_EVENT_AND_LAST_ID/GET_REQUEST';
export const TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_RESPONSE =
  'matchcenter24/TIMELINE_CMD_BY_EVENT_AND_LAST_ID/GET_RESPONSE';
export const TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_INVALIDATE =
  'matchcenter24/TIMELINE_CMD_BY_EVENT_AND_LAST_ID/GET_INVALIDATE';

// Competitions fetching related actions
export const COMPETITIONS_GET_REQUEST = 'matchcenter24/COMPETITIONS/GET_REQUEST';
export const COMPETITIONS_GET_RESPONSE = 'matchcenter24/COMPETITIONS/GET_RESPONSE';
export const COMPETITIONS_GET_INVALIDATE = 'matchcenter24/COMPETITIONS/GET_INVALIDATE';

// Stats Data by id
export const STATS_DATA_BY_EVENT_ID_GET_REQUEST =
  'matchcenter24/STATS_DATA_BY_EVENT_ID/GET_REQUEST';
export const STATS_DATA_BY_EVENT_ID_GET_RESPONSE =
  'matchcenter24/STATS_DATA_BY_EVENT_ID/GET_RESPONSE';
export const STATS_DATA_BY_EVENT_ID_GET_INVALIDATE =
  'matchcenter24/STATS_DATA_BY_EVENT_ID/GET_INVALIDATE';

// Lineups by Event Id
export const MATCH_LINEUPS_BY_EVENT_ID_GET_REQUEST =
  'matchcenter24/MATCH_LINEUPS_BY_EVENT_ID/GET_REQUEST';
export const MATCH_LINEUPS_BY_EVENT_ID_GET_RESPONSE =
  'matchcenter24/MATCH_LINEUPS_BY_EVENT_ID/GET_RESPONSE';
export const MATCH_LINEUPS_BY_EVENT_ID_GET_INVALIDATE =
  'matchcenter24/MATCH_LINEUPS_BY_EVENT_ID/GET_INVALIDATE';

// Standings by season and group
export const STANDINGS_BY_SEASON_GROUP_GET_REQUEST =
  'matchcenter24/STANDINGS_BY_SEASON_GROUP/GET_REQUEST';
export const STANDINGS_BY_SEASON_GROUP_GET_RESPONSE =
  'matchcenter24/STANDINGS_BY_SEASON_GROUP/GET_RESPONSE';
export const STANDINGS_BY_SEASON_GROUP_GET_INVALIDATE =
  'matchcenter24/STANDINGS_BY_SEASON_GROUP/GET_INVALIDATE';

// Escenic Teaser Articles
export const TEASER_ARTICLES_GET_REQUEST = 'escenic/TEASER_ARTICLES/GET_REQUEST';
export const TEASER_ARTICLES_GET_RESPONSE = 'escenic/TEASER_ARTICLES/GET_RESPONSE';
export const TEASER_ARTICLES_GET_INVALIDATE = 'escenic/TEASER_ARTICLES/GET_INVALIDATE';

// WP Teaser Articles
export const TEASER_WP_ARTICLES_GET_REQUEST = 'wordpress/TEASER_ARTICLES/GET_REQUEST';
export const TEASER_WP_ARTICLES_GET_RESPONSE = 'wordpress/TEASER_ARTICLES/GET_RESPONSE';
export const TEASER_WP_ARTICLES_GET_INVALIDATE = 'wordpress/TEASER_ARTICLES/GET_INVALIDATE';

// TV program Events
export const TVPROGRAM_EVENTS_GET_REQUEST = 'tvprogram/TVPROGRAM_EVENTS/GET_REQUEST';
export const TVPROGRAM_EVENTS_GET_RESPONSE = 'tvprogram/TVPROGRAM_EVENTS/GET_RESPONSE';
export const TVPROGRAM_EVENTS_GET_INVALIDATE = 'tvprogram/TVPROGRAM_EVENTS/GET_INVALIDATE';

// Date Tabs
export const DATETABS_SET_TYPE = 'matchcenter24/DATETABS/SET_TYPE';
export const DATETABS_SET_TABS = 'matchcenter24/DATETABS/SET_TABS';
export const DATETABS_SELECT_TAB = 'matchcenter24/DATETABS/SELECT_TAB';

// Sport Filter
export const SPORTFILTER_SET_FILTER = 'matchcenter24/SPORTFILTER/SET_FILTER';

// Sport events by group id
export const SPORTEVENTS_BY_GROUP_ID_GET_REQUEST =
  'matchcenter24/SPORTEVENTS_BY_GROUP_ID/GET_REQUEST';
export const SPORTEVENTS_BY_GROUP_ID_GET_RESPONSE =
  'matchcenter24/SPORTEVENTS_BY_GROUP_ID/GET_RESPONSE';
export const SPORTEVENTS_BY_GROUP_ID_GET_INVALIDATE =
  'matchcenter24/SPORTEVENTS_BY_GROUP_ID/GET_INVALIDATE';
